// START Open Requre.JS wrapper
define([
	'jquery',
	'pubsub',
	'jquery.hoverintent',
	'shared.main.screen',
	'wcs.utils'
], function($,pubsub, hoverIntent, screenSize, utils) {
// END Open Require.JS wrapper


/****
* Shows/hides more menu navigation dropdowns by clicking the more l1 link
* visible on medium up screens.
***/
	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "topnavmoredropdown";
	var topnavmoredropdown;
	var newTransparentTopNav = false;
	
	(function(){
		topnavmoredropdown = {
			defaults: {
				el: ".topnav-mainnav",
				activeItem: ".active",
				dataAttr: "topnav-more-dropdown-options",
				dropdownCloseButton: "topnav-mainnav-more-dropdown-close",
				dropdownWrapper: "topnav-mainnav-more-dropdown-wrapper",
				itemLink: ".topnav-accordion-item-link",
				moreItem: ".l1.topnav-list, .l1.more",
				moreLink: " > a",
				topnav: '.topnav',
				moreDropdown: ".topnav-dropdown-list, .topnav-mainnav-more-dropdown",
				moreDropdownClose: ".topnav-mainnav-more-dropdown-close",
				moreDropdownL1s: ".topnav-mainnav-more-menu .l1",
				moreMenu: ".topnav-mainnav-more-menu",
				rateLimit: 150,
				topNavNewHeader: '.top-nav-header'
			},

			/**
				* Initialize Topnav Dropdown Functions
				**/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this;
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );
				self.config.$header = self.$element;
				self.config.$topnav = self.config.$header.closest(self.config.topnav);

				self.events();

				self.keyPressCounterReset = 0;
				self.keyPressCounter = self.keyPressCounterReset;
				self.menuStatus = 'inactive';
				if(self.config.$topnav.closest('.transperant-topnav').length) {
                    newTransparentTopNav = true;
                }

				self.deferred.resolve();

				return self;
			},

			/**
				* Dropdown events
				**/
			events : function() {
				var self = this,
					moreItem = $(self.config.moreItem);

				// Resizing window will trigger hide l1 open dropdown and remove active class
				$.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
					self.hideMoreDropdown(moreItem);
				});

				// Re-bind dropdown events when item is removed from more menu
				$.pubsub('subscribe', 'vfdp.aem.topnav.moreMenu.remove.list', function(msg, $el) {
					self.bindDropdownMenuEvents($el);
				});

				// Un-bind dropdown events when item is added more menu
				$.pubsub('subscribe', 'vfdp.aem.topnav.moreMenu.add.list', function(msg, $el) {
					self.unbindDropdownMenuEvents($el);
				});

				self.bindDropdownMenuEvents(moreItem);

				// Clicking/tapping close button will close dropdown
				moreItem.find(self.config.moreDropdownClose).on('click touch', function(e) {
					e.preventDefault();
					e.stopPropagation();
					var activeMenu = $(this).closest(self.config.activeItem);
					self.hideMoreDropdown(activeMenu);
				});

				// add indexes after more menu is finished being drawn
				$.pubsub('subscribe','vfdp.aem.topnav.moreMenu.updated', function(event,data) {
					self.addTabIndexToDropdownElements();
				});

				// Open more dropdown should be closed if other l1 dropdown menu is opened
				$.pubsub('subscribe','vfdp.aem.topnav.dropdown.opened', function(event, data) {
					if(moreItem.hasClass('active')) {
						self.hideMoreDropdown(moreItem);
					}
				});
			},

			// unbind events from simple-list when they are moved to the more menu (triggered from mainNav.js)
			unbindDropdownMenuEvents: function(el) {
				var self = this;

				el.off('mouseenter mouseleave');
				el.find(self.config.moreLink).off('tap');
				el.off('keydown');
			},

			// bind events to more menu and simple-list on initial load and when simple-lists are removed from more menu (triggered from mainNav.js)
			bindDropdownMenuEvents: function(el) {
				var self = this;

				// Tapping on more link item will open/close more dropdown menu
				el.find(self.config.moreLink).on('tap', function(e) {
					if(screenSize.size() !== 'small') {
						e.preventDefault();
						var tappedLink = $(this).closest(self.config.moreItem);
						if(!tappedLink.hasClass('active')) {
							self.animateMoreOpen(tappedLink);
						} else {
							self.animateMoreClosed(tappedLink);
						}
					}
				});

				// Mousing over more link will open more dropdown and close on mouseleave
				el.hoverIntent({
					over: function(){
						if(screenSize.size() !== 'small') {
							self.animateMoreOpen($(this));
						}
					},
					out: function(event){
						if(screenSize.size() !== 'small') {
							self.hideMoreDropdown($(this));
						}
					},
					timeout: self.config.rateLimit
				});

				// Bind keyboard events to more menu
				el.on('keydown', self, self.topnavMoreMenuKeyDownHandler);
			},

			addTabIndexToDropdownElements: function() {
				var self = this,
					tabbableElements = $('.topnav-mainnav-more-dropdown .l1 > a');

				// Add tabIndex to More Dropdown Elements for Keyboard accessibility
				for(var i = 0; i < tabbableElements.length; i++) {
					$(tabbableElements[i]).attr('tabindex', i+1);
				}
			},

			// This function returns the position the more dropdown absolutely
			// between the center of the more link
			calculateMoreDropdownPosition: function($moreLink, $moreDropdown) {
				var self = this,
					moreLinkLeftPosition = $moreLink.offset(),
					moreLinkWidth = $moreLink.outerWidth(),
					moreDropdownWidth = $moreDropdown.outerWidth(),
					moreDropdownPosition = (moreLinkLeftPosition.left - (moreDropdownWidth / 2)) + (moreLinkWidth / 2),
					windowWidth = $(window).outerWidth();

				// center more dropdown below more link or position completely within window
				moreDropdownPosition = Math.min( moreDropdownPosition, (windowWidth - moreDropdownWidth) );

				// prevent dropdown from being positioned off-screen
				if(moreDropdownPosition < 0) moreDropdownPosition = 0;

				return moreDropdownPosition;
			},

			/** Hide More Dropdown function
			* removes active class from .l1.more
			*/
			hideMoreDropdown: function(el) {
				var self = this,
				$moreLink = el.find(self.config.moreLink),
				$moreDropdown = el.find(self.config.moreDropdown);

				$moreLink.attr({'aria-expanded':'false'});

				// stop any existing transitions first
				utils.interruptTransitions($moreDropdown, function() {
					// remove active class from l1.more
					el.removeClass('active');
					self.moreToggleTransperantTopNav('hide');

					// remove any styles that may have been set by animating
					$moreDropdown.css({'display': '', 'height': ''});
				});

				// Unbind the global onetime click events
				$('body').off('click touchstart scroll scrollstart', self.handleDismissMoreDropdown);

				// Publish event notifying other plugins the More Dropdown is closed
				$.pubsub('publish','vfdp.aem.topnav.moreDropdown.closed');
			},

			/** Show More Dropdown function
			* adds active class to .l1.more and hides any other open l1s
			*/
			showMoreDropdown: function(el) {
				var self = this,
					$moreLink = el.find(self.config.moreLink),
					$moreDropdown = el.find(self.config.moreDropdown);

				// add active class to more
				el.addClass('active');

				$moreLink.attr({'aria-expanded':'true'});

				// position more dropdown relative to the more button
				$moreDropdown.css('left', self.calculateMoreDropdownPosition($moreLink, $moreDropdown));

				// Close when a user clicks outside the more dropdown menu
				$('body').on('click touchstart scroll scrollstart', self, self.handleDismissMoreDropdown);

				// Publish event notifying other plugins the More Dropdown is opened
				$.pubsub('publish','vfdp.aem.topnav.moreDropdown.opened');
			},

			animateMoreOpen: function(element) {
				var self = this,
				$moreLink = element.find(self.config.moreLink),
				$moreDropdown = element.find(self.config.moreDropdown),
				elementTransition,
				sectionHeight;

				$moreLink.attr({'aria-expanded':'true'});

				if(!element.hasClass('active')) {

					// assign dropdown/promobar transitions to variables
					elementTransition = $moreDropdown[0].style.transition;

					// clear transitions temporarilty to get height before transitioning
					$moreDropdown[0].style.transition = '';

					// add active class to more, set dropdown visible
					element.addClass('active');
					$moreDropdown.css({'display': 'block','height':'0'});

					// replace transitions
					$moreDropdown[0].style.transition = elementTransition;

					// get height of dropdown
					sectionHeight = $moreDropdown[0].scrollHeight;

					// position more dropdown relative to the more button
					$moreDropdown.css('left', self.calculateMoreDropdownPosition($moreLink, $moreDropdown));
					self.moreToggleTransperantTopNav('show');

					var animationComplete = function() {
						// remove "height" from the element's inline styles, so it can return to its initial value
						$moreDropdown[0].style.height = '';
						// remove this event listener so it only gets triggered once
						$moreDropdown[0].removeEventListener('transitionend', animationComplete);
					};

					// when the css transition finishes
					$moreDropdown[0].addEventListener('transitionend', animationComplete);

					// stop any existing transitions first
					utils.interruptTransitions($moreDropdown, function() {
						// have the element transition to the height of dropdown content
						$moreDropdown[0].style.height = sectionHeight + 'px';
					});

					// Publish event notifying other plugins the More Dropdown is opened
					$.pubsub('publish','vfdp.aem.topnav.moreDropdown.opened');
				}

				// Close when a user clicks outside the more dropdown menu
				$('body').on('click touchstart scroll scrollstart', self, self.handleDismissMoreDropdown);
			},

			moreToggleTransperantTopNav: function(navState) {
                if(!newTransparentTopNav) return;

                var self = this,
                topNavNewBar = $(self.config.topNavNewHeader);

                if(navState == 'show') {
                    topNavNewBar.addClass('new-transperant-topnav')
                }else{
                    topNavNewBar.removeClass('new-transperant-topnav')
                }   
            },

			animateMoreClosed: function(element) {
				var self = this,
				$moreLink = element.find(self.config.moreLink),
				$moreDropdown = element.find(self.config.moreDropdown),
				sectionHeight,
				elementTransition;

				$moreLink.attr({'aria-expanded':'false'});

				// get height of dropdown
				sectionHeight = $moreDropdown[0].scrollHeight;

				// assign dropdown/promobar transitions to variables
				elementTransition = $moreDropdown[0].style.transition;

				// clear transitions temporarilty to get height before transitioning
				$moreDropdown[0].style.transition = '';
				self.moreToggleTransperantTopNav('hide');

				var animationComplete = function() {

					// at the end of the transition remove element's inline styles, so it can return to its initial value
					$moreDropdown[0].style.display = '';
					$moreDropdown[0].style.height = '';
					$moreDropdown.closest('.l1').removeClass('active');
					// remove this event listener so it only gets triggered once
					self.moreToggleTransperantTopNav('hide');
					$moreDropdown[0].removeEventListener('transitionend', animationComplete);
				};


				// set the element's height to its current pixel height before replacing transitions
				requestAnimationFrame(function() {
					// stop any existing transitions first
					utils.interruptTransitions($moreDropdown, function() {
						$moreDropdown[0].style.height = sectionHeight + 'px';
						$moreDropdown[0].style.transition = elementTransition;
					});

					// transition height to 0
					requestAnimationFrame(function() {
						$moreDropdown[0].addEventListener('transitionend', animationComplete);
						$moreDropdown[0].style.height = 0 + 'px';
					});
				});


				// Unbind the global onetime click events
				$('body').off('click touchstart scroll scrollstart', self.handleDismissMoreDropdown);
			},

			/**
			 * Handles the one-time events to close the More Dropdown when
			 * user interacts with the page outside the More Dropdown
			 * @param event JQuery Event
			 **/
			handleDismissMoreDropdown: function(event) {
				var self = event.data;
				if (!$(event.target).closest(self.config.moreItem).length && !$(event.target).closest(self.config.moreDropdown).length) {
					self.hideMoreDropdown($(self.config.moreItem));
				}
			},

			/**
			* Handles keyboard events for l1s inside more menu dropdown
			* for user accessibility interactions
			* @param event JQuery Event
			**/
			topnavMoreMenuKeyDownHandler: function(event) {
				var self = event.data,
					$this = $(this),
					$focusedLink = $this.find($(":focus")), // the <a> in the nagivation
					$focusedParent = $focusedLink.parent(), // the <li> wrapping the focused <a>
					$focusedDropdown = $focusedParent.closest('.' + self.config.dropdownWrapper),
					$nextLink,
					$prevLink,
					isMainNavItem = ($focusedParent.hasClass("more") || $focusedParent.hasClass("topnav-list")),
					keys = {
						down: 40,
						enter: 13,
						esc: 27,
						left: 37,
						right: 39,
						space: 32,
						tab: 9,
						up: 38
					};

				switch(event.keyCode) {

					// *** ENTER or SPACE ***
					// If focused on More L1 link, toggle the dropdown open/closed. 
					// When opening a dropdown, close button receives focus.
					// When focused on close button, close the dropdown.
					// Otherwise, use default action for pressed key.
					case keys.enter:
					case keys.space:
						// toggle dropdown open/close
						if(isMainNavItem) {
							event.preventDefault();
							// close the dropdown
							if($focusedParent.hasClass('active')) {
								self.hideMoreDropdown($this);
							}
							// open dropdown, focus on close button
							else {
								self.showMoreDropdown($this);
								$focusedParent.find('.' + self.config.dropdownCloseButton).focus();
							}
						}

						// if focused on close button, close drodown
						else if($focusedLink.hasClass(self.config.dropdownCloseButton)) {
							event.preventDefault();
							self.hideMoreDropdown($this);
							$focusedLink.closest('.more').find(self.config.moreLink).focus();
						}
					break;


					case keys.tab:
						if($focusedLink.hasClass(self.config.dropdownCloseButton)) {
							event.preventDefault();
							$focusedDropdown.find(self.config.itemLink).first().focus();
						}
					break;

					// *** DOWN ARROW ***
					// When focus is on an L1, open the dropdown and focus on close button
					// When focus is inside a dropdown, focus moves to next item within dropdown
					// Focus should cycle through the current dropdown, excluding close button
					case keys.down:

						event.preventDefault();

						if(isMainNavItem) {
							self.showMoreDropdown($this);
							$focusedParent.find('.' + self.config.dropdownCloseButton).focus();
						}
						else if($focusedLink.hasClass(self.config.dropdownCloseButton)) {
							$focusedDropdown.find(self.config.itemLink).first().focus();
						}
						else {
							$nextLink = $focusedParent.next().find('> a');
							// go to first link from last link
							if(!$nextLink.length) {
								$nextLink = $focusedDropdown.find(self.config.itemLink).first();
							}

							$nextLink.focus();
						}
					break;

					// *** UP ARROW ***
					// When focus is inside a dropdown, focus moves to previous item within dropdown
					// Focus should cycle through the current dropdown, excluding close button
					case keys.up:
						event.preventDefault();
						if(!isMainNavItem && $focusedParent.hasClass('l1')) {
							$nextLink = $focusedParent.prev().find('> a');
							// go to last link from first link
							if(!$nextLink.length) {
								$nextLink = $focusedDropdown.find(self.config.itemLink + ":visible").last();
							}
							$nextLink.focus();
						}
					break;

					// *** RIGHT ARROW ***
					// When focus is on an L1, move to next L1
					case keys.right:
						if(isMainNavItem) {
							$nextLink = $focusedParent.next().find('> a');

							// move focus to first L1
							if(!$nextLink.length) {
								$nextLink = self.$element.find('.l1').first().find('> a');
							}
							$nextLink.focus();
						}
					break;

					// *** LEFT ARROW ***
					// When focus is on an L1, move to prev L1
					case keys.left:
						if(isMainNavItem) {
							$prevLink = $focusedParent.prev().find('> a');

							// move focus to last L1
							if(!$prevLink.length) {
								$prevLink = self.$element.find('.l1').last().find('> a');
							}
							$prevLink.focus();
						}
					break;

					// *** ESC ***
					// When focused inside a dropdown, closes a dropdown
					case keys.esc:
						if($focusedDropdown.closest('.l1').hasClass('active')) {
							event.preventDefault();
							self.hideMoreDropdown($this);
							$focusedLink.closest('.more').find(self.config.moreLink).focus();
						}
					break;
				}
			}
		};

		return topnavmoredropdown.init();

	})();

	return topnavmoredropdown;
});
